import React, { useState } from 'react';
import { TabContent, TabPane, Form, Label, Button } from 'reactstrap';
import '../../Contracts/MyContracts.scss';
import { useTranslation } from 'react-i18next';
import { Row, Col } from 'reactstrap';

import { ReactComponent as IconBuilding } from '../../../images/icn_buildings.svg';
import {
  BtnOutlineGreen,
  ContFilterYear,
  ContFlexRight,
  ContPaginationPage,
} from '../../../styled-components';
import FormGroup from 'reactstrap/lib/FormGroup';
import CustomInput from 'reactstrap/lib/CustomInput';

import SearchInput from '../../../commons/SearchInput';
import Footer from '../../../commons/Footer';
import Header from '../../../commons/Header';
import generatePaginationOptions from '../../../lib/helpers/generatePaginationOptions';
import ContractsTableEnergyTab from './ContractsTableEnergyTab';
import ModalConfirm from '../../../commons/ModalConfirm';
import ModalInvoiceDetail from '../../../commons/ModalInvoiceDetail';
import currency from 'currency.js';
import generateYearOptions from '../../../lib/helpers/generateYearOptions';
import generateMonthOptions from '../../../lib/helpers/generateMonthOptions';
import ContractsImportPaidsFeedbackModal from './ContractsImportPaidsFeedbackModal';
import { useAlert } from 'react-alert';
import ContractsImportPaidsFeedbackModalPolis from './ContractsImportPaidsFeedbackModalPolis';

const EnergyRecurringPresentational = ({
  data,
  profile,
  query,
  total,
  onFilter,
  onCondoUpdate,
  onChangeAdmin,
  onExtendAdminManagement,
  checkVatCode,
  selectedContracts,
  onSelectChange,
  onInvoice,
  onSelectAll,
  selectedAll,
  onStatusChanged,
  totPod = 0,
  totPdr = 0,
  onAddPayment,
  onImportContractPaids,
  onImportContractPaidsPolis,
  contractsImportFeedbackData,
  contractsImportFeedbackDataPolis,
  hasImportedContracts,
  hasImportedContractsPolis,
  toggleShowImportFeedback,
  toggleShowImportFeedbackPolis,
  handleFileListView,
  handleDelete,
}) => {
  const [t] = useTranslation('CONTRACTS');
  const { offset, limit } = query;
  const alert = useAlert();

  const [modalState, setModalState] = useState({
    isOpen: false,
    selectedId: null,
  });
  const [totalContractsExtrashare, setTotalContractsValue] = useState(0);

  const onOpenModal = () => {
    const itemsForTotalValue = selectedContracts.map((_id) => {
      return data.find((contract) => contract._id === _id).extraShare;
    });
    let total = 0;
    itemsForTotalValue.forEach((value) => {
      total += value;
    });
    setTotalContractsValue(
      currency(total, { symbol: '€', precision: 2 }).format()
    );
  };

  function handleImportFile(event) {
    const file = event.target?.files[0];

    const fileSize = (Number(file?.size || 0) / 1024 ** 2).toFixed(2);

    if (fileSize > 20) {
      alert.info('File troppo grande. Sono ammessi file di massimo 20MB');
    } else {
      const data = new FormData();
      data.append('file', file);
      onImportContractPaids(data);
    }
  }

  function handleImportFilePolis(event) {
    const file = event.target?.files[0];

    const fileSize = (Number(file?.size || 0) / 1024 ** 2).toFixed(2);

    if (fileSize > 20) {
      alert.info('File troppo grande. Sono ammessi file di massimo 20MB');
    } else {
      const data = new FormData();
      data.append('file', file);
      onImportContractPaidsPolis(data);
    }
  }

  return (
    <section>
      <ContractsImportPaidsFeedbackModal
        data={contractsImportFeedbackData}
        toggle={toggleShowImportFeedback}
        isOpen={hasImportedContracts}
      />

      <ContractsImportPaidsFeedbackModalPolis
        data={contractsImportFeedbackDataPolis}
        toggle={toggleShowImportFeedbackPolis}
        isOpen={hasImportedContractsPolis}
      />

      <TabContent activeTab={'1'}>
        <TabPane tabId="1">
          <section>
            <Header
              title={t('PAGES:CONTRACTS')}
              icon={<IconBuilding fill="#ffffff" style={{ height: '25px' }} />}
            />

            <Row className="align-items-center">
              <Col className="">
                <ContFlexRight>
                  Contratti POD:&nbsp;<strong>{totPod}</strong>&nbsp; |
                  Contratti PDR:&nbsp;<strong>{totPdr}</strong>
                </ContFlexRight>
              </Col>
            </Row>

            {profile.polis !== true && (
              <Row>
                <Col sm="12" md="12" lg="4" xl="4">
                  <Button
                    href={`/examples/Template_Contratti_Ricorrenti_Incassi.csv`}
                    target="_blank"
                    color="primary"
                    style={{ width: '100%' }}
                  >
                    Scarica template importazione
                  </Button>
                </Col>
                <Col sm="12" md="12" lg="4" xl="4">
                  <Button
                    href={`/documentation/Extra_Importazione_contratti_ricorrenti_incassi.pdf`}
                    target="_blank"
                    color="primary"
                    style={{ width: '100%' }}
                  >
                    Scarica documentazione importazione
                  </Button>
                </Col>
              </Row>
            )}

            <Row className="search-add-cont m-t-20" style={{ rowGap: '20px' }}>
              <Col sm="12" md="6" lg="3" className="select-wrapper">
                <ContFilterYear
                  className="no-width"
                  style={{ marginBottom: '0' }}
                >
                  <Row>
                    <Col xs="6">
                      <Label>{t('COMMON:TITLE_FILTER_DATE_FEE_YEAR')}</Label>
                    </Col>
                    <Col xs="6">
                      <FormGroup>
                        <CustomInput
                          type="select"
                          id="selectdateFeeYear"
                          name="dateFeeYear"
                          value={query && query.dateFeeYear}
                          onChange={({ target: { value: dateFeeYear } }) => {
                            onFilter({ dateFeeYear });
                          }}
                        >
                          {generateYearOptions()}
                        </CustomInput>
                      </FormGroup>
                    </Col>
                  </Row>
                </ContFilterYear>
              </Col>

              <Col sm="12" md="6" lg="3" className="select-wrapper">
                <ContFilterYear
                  className="no-width"
                  style={{ marginBottom: '0' }}
                >
                  <Row>
                    <Col xs="6">
                      <Label>{t('COMMON:TITLE_FILTER_DATE_FEE_MONTH')}</Label>
                    </Col>
                    <Col xs="6">
                      <FormGroup>
                        <CustomInput
                          type="select"
                          id="dateFeeMonth"
                          name="dateFeeMonth"
                          disabled={!query.dateFeeYear}
                          value={query && query.dateFeeMonth}
                          onChange={({ target: { value: dateFeeMonth } }) =>
                            onFilter({ dateFeeMonth })
                          }
                        >
                          {generateMonthOptions()}
                        </CustomInput>
                      </FormGroup>
                    </Col>
                  </Row>
                </ContFilterYear>
              </Col>

              {!(profile && profile._id) && (
                <Col sm="6" md="6" lg="3" xl="3">
                  <SearchInput
                    query={{ search: query && query.admin }}
                    onFilter={({ search }) => onFilter({ admin: search })}
                    label={t('SEARCH:ADMINISTRATOR')}
                  />
                </Col>
              )}
              <Col sm="6" md="6" lg="3" xl="3">
                <SearchInput
                  query={{ search: query && query.customer }}
                  onFilter={({ search }) => onFilter({ customer: search })}
                  label={t('SEARCH:CUSTOMER')}
                />
              </Col>
              <Col sm="6" md="6" lg="3" xl="3">
                <SearchInput
                  query={{ search: query && query.pod_pdr }}
                  onFilter={({ search }) => onFilter({ pod_pdr: search })}
                  label={t('SEARCH:POD_PDR')}
                />
              </Col>
              <Col sm="6" md="6" lg="3" xl="3">
                <SearchInput
                  query={{ search: query && query.condo_vat_cf }}
                  onFilter={({ search }) => onFilter({ condo_vat_cf: search })}
                  label={t('SEARCH:CLIENT_VAT_CODE')}
                />
              </Col>
              <Col sm="6" md="6" lg="3" xl="3">
                <SearchInput
                  query={{ search: query && query.condo_admin_cf }}
                  onFilter={({ search }) =>
                    onFilter({ condo_admin_cf: search })
                  }
                  label={t('SEARCH:ADMIN_VAT_CODE')}
                />
              </Col>

              <Col sm="12" md="6" lg="3">
                <ContFilterYear className="no-width">
                  <Row>
                    <Col xs="6">
                      <Label>Stato incasso</Label>
                    </Col>
                    <Col xs="6">
                      <FormGroup>
                        <CustomInput
                          type="select"
                          id="paid"
                          name="paid"
                          onChange={({ target: { value: paid } }) =>
                            onFilter({ paid })
                          }
                          value={query.paid || ''}
                        >
                          <option value="" defaultChecked>
                            Tutti
                          </option>
                          <option value="PAID">Pagato</option>
                          <option value="NOT_PAID">Non pagato</option>
                          <option value="NOT_BILLED">Da fatturare</option>
                        </CustomInput>
                      </FormGroup>
                    </Col>
                  </Row>
                </ContFilterYear>
              </Col>

              <Col sm="12" md="4" lg="3" xl="3" className="select-wrapper">
                <ContFilterYear
                  className="no-width"
                  style={{ marginBottom: '0' }}
                >
                  <Row>
                    <Col xs="6">
                      <Label>Tipo contratto</Label>
                    </Col>
                    <Col xs="6">
                      <FormGroup>
                        <CustomInput
                          type="select"
                          id="contractType"
                          name="contractType"
                          value={query.contractType}
                          onChange={({ target: { value: contractType } }) =>
                            onFilter({ contractType })
                          }
                        >
                          <option value="" defaultChecked>
                            Tutti
                          </option>
                          <option value="POD">POD</option>
                          <option value="PDR">PDR</option>
                        </CustomInput>
                      </FormGroup>
                    </Col>
                  </Row>
                </ContFilterYear>
              </Col>

              {profile.polis !== true && (
                <Col sm="12" md="6" lg="3" xl="3">
                  <FormGroup>
                    <CustomInput
                      type="file"
                      id="importFilee"
                      name="importFilee"
                      onChange={(event) => handleImportFile(event)}
                      accept=".csv"
                    />
                    <Label for="selectFile">
                      {t('ENERGY_CONTRACT:CHOOSE_FILE')}
                      &nbsp;({t('ENERGY_CONTRACT:MAX_UPLOAD_FILE_SIZE')})
                    </Label>
                  </FormGroup>
                </Col>
              )}

              {profile.polis === true && (
                <Col sm="12" md="6" lg="3" xl="3">
                  <FormGroup>
                    <CustomInput
                      type="file"
                      id="importFilePolis"
                      name="importFilePolis"
                      onChange={(event) => handleImportFilePolis(event)}
                      accept=".xlsx,.xls"
                    />
                    <Label for="importFilePolis">
                      {t('ENERGY_CONTRACT:CHOOSE_FILE_POLIS')}
                      &nbsp;({t('ENERGY_CONTRACT:MAX_UPLOAD_FILE_SIZE')})
                    </Label>
                  </FormGroup>
                </Col>
              )}
            </Row>
          </section>

          <section className="m-t-20">
            <ContractsTableEnergyTab
              data={data}
              profileType={profile.type}
              total={total}
              offset={offset}
              limit={limit}
              onFilter={onFilter}
              onCondoUpdate={onCondoUpdate}
              onChangeAdmin={onChangeAdmin}
              profile={profile}
              onExtendAdminManagement={onExtendAdminManagement}
              truncateTable={profile && profile._id}
              checkVatCode={checkVatCode}
              selectedContracts={selectedContracts}
              onSelectChange={onSelectChange}
              onSelectAll={onSelectAll}
              selectedAll={selectedAll}
              setModalState={setModalState}
              onAddPayment={onAddPayment}
              handleFileListView={handleFileListView}
              handleDelete={handleDelete}
              onStatusChanged={onStatusChanged}
            />

            <ContPaginationPage>
              <p>{t('COMMON:PAGINATION_PER_PAGE')}</p>

              <FormGroup>
                <CustomInput
                  type="select"
                  className="pagination-select"
                  id="perPage"
                  name="perPage"
                  value={limit}
                  onChange={({ target: { value: limit } }) => {
                    onFilter({ limit: limit });
                  }}
                >
                  {generatePaginationOptions()}
                </CustomInput>
              </FormGroup>
            </ContPaginationPage>

            <ModalInvoiceDetail
              modalState={modalState}
              setModalState={setModalState}
              onStatusChanged={onStatusChanged}
            />

            <ContFlexRight className="mt-5">
              {selectedContracts.length > 0 && (
                <ModalConfirm
                  onConfirm={() => {
                    onInvoice();
                  }}
                  onOpen={onOpenModal}
                  text={
                    `Il valore totale dei contratti é: ${totalContractsExtrashare} ` +
                    '\n' +
                    t('CONTACTS:CONFIRM_INVOICE')
                  }
                >
                  <BtnOutlineGreen type="button" className="uppercase">
                    FATTURA SELEZIONATI
                  </BtnOutlineGreen>
                </ModalConfirm>
              )}
            </ContFlexRight>
          </section>
          <Footer />
        </TabPane>
      </TabContent>
    </section>
  );
};

export default EnergyRecurringPresentational;
